<template>
  <div class="container-narrow my-4">
    <h1 class="title has-text-left">CSCS Card Types</h1>
    <div class="has-text-left mb-4">
      Here are the CSCS Cards you can apply for. Please note that you are
      required to hold the relevant qualification or equivalant qualification
      for applying a CSCS Card. The requirements can be found in <b>Know More</b> for each card.
    </div>
    <div class="columns">
      <div v-for="cardTypeId in [1, 2, 3]" :key="cardTypeId" class="column">
        <TestBox :card-type-id="cardTypeId" />
      </div>
    </div>

    <div class="columns mt-2">
       <div v-for="cardTypeId in [4, 5, 6]" :key="cardTypeId" class="column">
        <TestBox :card-type-id="cardTypeId" />
      </div>
    </div>

    <div class="columns mt-2">
      <div v-for="cardTypeId in [7, 8, 9]" :key="cardTypeId" class="column">
        <TestBox :card-type-id="cardTypeId" />
      </div>
    </div>

    <div class="columns mt-2">
      <div v-for="cardTypeId in [10, 11, 12]" :key="cardTypeId" class="column">
        <TestBox :card-type-id="cardTypeId" />
      </div>
    </div>
  </div>
</template>
<script>
import TestBox from '@/components/TestBox.vue';

export default {
  components: {
    TestBox,
  },
};
</script>
